
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
import { withStyles } from '@material-ui/core/styles';
import { documentStyles } from '../../../Styles/documentStyles';
import Images from '../../../Theme/Images';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';
import { ReactSVG } from 'react-svg'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Button from '@material-ui/core/Button';
import Loader from 'react-loader-spinner'
import IdleTimer from 'react-idle-timer';
import SubmitDialog from '../SubmitDialog';
import { Scrollbars } from 'react-custom-scrollbars';
import TabularData from './TabularData'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
const tabList = ['Non-tabular data', 'Tabular data'];
const writerCorpTabs = ['Tabular data', 'Non-tabular data'];

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
@inject('documentStore', 'dashboardStore')
@observer
class PoSoForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validationErrors: {},
            openSubmitDialog: false,
            currentField: '',
            activeTab: props.documentStore.currentDoc.docType === 'WRITERCORP' ? 'Tabular data' : 'Non-tabular data'
        }
        this._areaElement = new Map();
        this._areaElementBack = new Map();
    }

    handleTabChange = (event, value) => {
        if (this.props.documentStore.currentDoc.docType === 'WRITERCORP')
            this.setState({ activeTab: writerCorpTabs[value] })
        else
            this.setState({ activeTab: tabList[value] })
    };

    a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }


    handleFormFieldChange = (value, index, fieldId) => {
        this.props.documentStore.updateNonTabularField(value, index, fieldId)
    }

    ntn = () => {

    }

    getFormFields = (item, index) => {
        const { validationErrors } = this.state;
        const { classes } = this.props;

        const { imageFacingSide, currentPage, currentDoc } = this.props.documentStore;
        switch ('text') {
            case 'text':
                return (

                    <ListItem key={index} style={{ paddingTop: 0, marginTop: 0 }}>
                        <TextField
                            coords={item.pts && item.pts.slice()}
                            ref={c => this._areaElement.set(index, c)}
                            onClick={(e) => this.setCurrentField(e, index, item)}
                            color="primary"
                            style={{ paddingTop: 0, marginTop: 0 }}
                            required
                            id={item.aiKey}
                            key={item._id}
                            label={item.aiKey}
                            type={item.type}
                            margin="normal"
                            variant="filled"
                            fullWidth
                            multiline
                            InputProps={{
                                disableUnderline: true,
                                endAdornment:
                                    <InputAdornment position="end">
                                        {currentDoc.nonTabularData[index].progressIcon}
                                    </InputAdornment>

                            }}
                            value={item.editedValue !== "" && item.editedValue !== undefined ? item.editedValue : item.aiValue}
                            onChange={(event) => this.handleFormFieldChange(event.target.value, index, item._id, item.editedValue !== "" ? "editedValue" : "aiValue")}
                        />

                        {validationErrors[item.label] && <FormHelperText id={item.label}>{validationErrors[item.label]}</FormHelperText>}
                    </ListItem>

                )
        }
    }

    openDropDown = () => {
        this.props.documentStore.openDocumentDrawer()
    }

    onSubmit = (finalSubmit, autoSave, next) => {
        if (!next && !autoSave)
            this.setState({ openSubmitDialog: true })
        else {
            if (this.props.documentStore.currentDoc.docType === 'MEDIASSIST')
                this.props.documentStore.updateMediassistDocument(undefined, true)
            else if (this.props.documentStore.currentDoc.docType === 'WRITERCORP')
                this.props.documentStore.updateWritercorpDocument(undefined, true)
            else
                this.props.documentStore.updatePosoDocument(undefined, true)
        }
    }

    cancelSubmit = () => {
        this.setState({ openSubmitDialog: false })
    }

    downloadDoc = (doc) => {
        this.props.documentStore.exportXls(doc._id)
    }

    onCancel = () => {
        const { currentDoc } = this.props.documentStore;
        this.props.documentStore.resetCurrentField()
        if (currentDoc.docStatus === "REVIEW_PENDING")
            this.props.history.push("/dashboard/drafts");
        else if (currentDoc.docStatus === "REVIEW_COMPLETE")
            this.props.history.push("/dashboard/reviewed");
        else
            this.props.history.push("/dashboard/exported");
    }

    save = () => {
        const { updatedTabularFields, updatedNonTabularFields } = this.props.documentStore;
        if (updatedNonTabularFields.length || updatedTabularFields.length)
            this.onSubmit(false, true, false);
        else
            return
    }

    setCurrentField = (e, index, item) => {
        this.setState({
            currentField: index
        })
        this.props.documentStore.setCurrentField(item, index)

        this.props.documentStore.setCurrentPage(item.page !== null ? item.page : 0)
        this.props.highlight(e, index)
    }

    exportDoc = () => {
        const { currentDoc } = this.props.documentStore;
        let temp = [];
        temp.push(currentDoc._id);
        this.props.dashboardStore.exportXls(temp, 'EXPORTED')

    }

    componentWillUnmount() {
        this.props.removeHighlight(undefined, this.props.documentStore.currentIndex)
    }

    changePage = (type) => {
        const { currentPage, currentDoc } = this.props.documentStore;
        let index = currentDoc.pageArray.findIndex(x => x._id === currentPage._id);
        this.props.resetImage()
        if (type === '-')
            this.props.documentStore.setCurrentImagePoSo(currentDoc.pageArray[index - 1], index - 1);
        else
            this.props.documentStore.setCurrentImagePoSo(currentDoc.pageArray[index + 1], index + 1);
    }

    finalSubmit = () => {
        if (this.props.documentStore.currentDoc.docType === 'MEDIASSIST')
            this.props.documentStore.updateMediassistDocument()
                .then((resp) => {
                    if (!this.props.documentStore.updateProgress)
                        this.onCancel()
                })
        else if (this.props.documentStore.currentDoc.docType === 'WRITERCORP')
            this.props.documentStore.updateWritercorpDocument(undefined, true)
                .then((resp) => {
                    if (!this.props.documentStore.updateProgress)
                        this.onCancel()
                })
        else
            this.props.documentStore.updatePosoDocument()
                .then((resp) => {
                    if (!this.props.documentStore.updateProgress)
                        this.onCancel()
                })

    }


    render() {
        const { classes, theme } = this.props;
        const { activeTab } = this.state;
        const { currentPage, currentDoc, inProgress, updateProgress } = this.props.documentStore;
        return (
            <div className={classes.formDiv}>
                <div onMouseOver={(e) => this.openDropDown()} style={{ height: '1vh' }}></div>
                <div className={classes.headerContainer}>
                    <div className={classes.docHeader}>{currentDoc.originalFileName}
                        {<KeyboardArrowDownIcon className={classes.dropDownIcon} onClick={(e) => this.openDropDown()}></KeyboardArrowDownIcon>}
                    </div>
                    {currentDoc.pageArray[currentDoc.pageArray.length - 1]._id === currentPage._id && currentPage.reviewed ? <ReactSVG src={Images.exportSingle} onClick={(e) => this.exportDoc()} beforeInjection={svg => { svg.classList.add(classes.svg) }} /> : null}
                </div>
                <Tabs indicatorColor="primary" value={this.props.documentStore.currentDoc.docType === 'WRITERCORP' ? writerCorpTabs.findIndex(x => x === activeTab) : tabList.findIndex(x => x === activeTab)} onChange={this.handleTabChange} aria-label="simple tabs example">
                    {
                        this.props.documentStore.currentDoc.docType === 'WRITERCORP' ?
                            writerCorpTabs.map((row, index) => (
                                <Tab key={'tab' + index} color="primary" style={{ color: theme.palette.white, fontSize: '13px' }} label={row} {...this.a11yProps(index)} />
                            )) :
                            tabList.map((row, index) => (
                                <Tab key={'tab' + index} color="primary" style={{ color: theme.palette.white, fontSize: '13px' }} label={row} {...this.a11yProps(index)} />
                            ))
                    }
                </Tabs>
                <form noValidate autoComplete="off" className={classes.formStyle}>
                    <TabPanel style={{ marginTop: '-3vh', marginLeft: '-1vw', marginRight: '-1vw', flexGrow: '1', height: '100%' }} value={this.props.documentStore.currentDoc.docType === 'WRITERCORP' ? writerCorpTabs.findIndex(x => x === activeTab) : tabList.findIndex(x => x === activeTab)} index={this.props.documentStore.currentDoc.docType === 'WRITERCORP' ? writerCorpTabs.findIndex(x => x === activeTab) : tabList.findIndex(x => x === activeTab)}>
                        {
                            activeTab === 'Non-tabular data' ?
                                <IdleTimer style={{ height: '100%' }} ref="saveTimer" debounce={5000} timeout={10000} startOnLoad={false} >

                                    <div style={{ overflowY: 'scroll', height: '68vh' }}>
                                        <List>
                                            {
                                                currentDoc.nonTabularData.map((item, index) => {
                                                    return this.getFormFields(item, index)
                                                })
                                            }
                                        </List>

                                    </div>

                                </IdleTimer>
                                :
                                <IdleTimer ref="saveTimer"
                                    //onAction={this.save} 
                                    debounce={1000} timeout={10000} startOnLoad={false} >
                                    <Scrollbars>
                                        {currentDoc.pageArray && currentDoc.pageArray.length ?
                                            currentDoc.pageArray.map((row, pageIndex) => (
                                                <TabularData docType={this.props.documentStore.currentDoc.docType} key={'tabularData' + pageIndex} pageIndex={pageIndex} highlight={this.props.highlightTabularData} />
                                            ))
                                            : null
                                        }
                                    </Scrollbars>
                                </IdleTimer>
                        }
                    </TabPanel>
                </form>

                <div className={classes.formSubmitContainer}>
                    <div>
                        {
                            updateProgress ?
                                <Button variant="contained" className={classes.submitButton} fullWidth>
                                    <Loader height={30} width={30} color={this.props.theme.palette.white} />
                                </Button>
                                : <Button onClick={(event) => this.onSubmit(true, false, false)} variant="contained" className={classes.submitButton} type="submit" fullWidth>
                                    Submit
                                    </Button>

                        }
                        <Button onClick={(event) => this.onCancel()} variant="contained" style={{ backgroundColor: this.props.theme.palette.dark }} className={classes.submitButton} type="submit" fullWidth>
                            Cancel
                        </Button>
                    </div>

                    {currentDoc.exportUrl !== undefined ?
                        <Button variant="contained" className={classes.submitButton} type="submit" onClick={(event) => { this.downloadDoc(currentDoc) }} fullWidth>
                            Download
                        </Button> : null
                    }
                </div>
                <SubmitDialog open={this.state.openSubmitDialog} cancelSubmit={this.cancelSubmit} submit={this.finalSubmit}></SubmitDialog>
            </div>

        )
    }
}
export default withStyles(documentStyles, { withTheme: true })(withRouter(PoSoForm));
